//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import Card from "@/components/common/card.comp.vue";
export default {
  name: "Episodes",
  data() {
    return {
      showDetails: true
    };
  },
  props: {
    seasons: Object,
    detail: Boolean
  },
  components: {
    Card
  }
};
